import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter
} from "@angular/core";
import { ModaleRicercaDocumentoComponent } from "../modale-ricerca-documento/modale-ricerca-documento.component";
import { DocumentoVO } from "@app/shared/vo/documentoVO";

@Component({
  selector: "app-ricerca-documento",
  templateUrl: "./ricerca-documento.component.html"
})
export class RicercaDocumentoComponent implements OnInit {
  @ViewChild("modaleRicercaDocumento", { static: false })
  public modaleRicercaDocumento: ModaleRicercaDocumentoComponent;

  @Output() emettiDocumento: EventEmitter<DocumentoVO> = new EventEmitter<
    DocumentoVO
  >();

  constructor() {}
  ngOnInit() {}
  public cercaDocumento() {
    console.log("[RicercaDocumentoComponent][cercaDocumento]");
    this.modaleRicercaDocumento.openModal();
  }

  ricevoDocumento(row: DocumentoVO) {
    this.emettiDocumento.emit(row);
  }
}
